import InvoiceDetailsSection from '@/components/Settings/InvoiceDetailsSection'
import SettingsKpiCards from '@/components/Settings/SettingsKpiCards'
import { BILLING_KPI } from '@/components/Settings/settingsKpiPlaceholders'
import { getSettingsSectionIntro } from '@/components/Settings/settingsSectionDescriptions'

export default function SettingsBillingSection() {
  return (
    <>
      <SettingsKpiCards sectionTitle="Billing metrics" intro={getSettingsSectionIntro('billing-metrics')} items={BILLING_KPI} />
      <InvoiceDetailsSection />
    </>
  )
}
